<template>
  <div>
    <BContainer>
      <div class="columns">
        <div class="column">
          <b-field grouped group-multiline>
            <a class="button is-primary" @click="openEditModal(null)">{{ $t('button.new') }}</a>
          </b-field>
        </div>
      </div>
      <b-table
        :data="data"
        ref="table"
        :striped="true"
        :mobile-cards="true"
        detailed
        hoverable
        :show-detail-icon="showDetailIcon"
        custom-detail-row
        detail-key="id"
        :has-detailed-visible="row => row.companies.length > 0"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$t('validation.attributes.name')" sortable>
            <template v-if="props.row.companies.length < 1">{{ props.row.name }}</template>
            <template v-else>
              <a @click="toggle(props.row)">{{ props.row.name }}</a>
            </template>
          </b-table-column>
          <b-table-column width="120" centered>
            <div class="buttons">
              <b-button icon-right="edit" @click="openEditModal(props.row.id)" />
              <b-button icon-right="trash-alt" @click="deleteItem(props.row.id)" />
            </div>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <tr v-for="item in props.row.companies" :key="item.name">
            <td v-if="showDetailIcon"></td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</td>
            <td>
              <div class="buttons">
                <b-button icon-right="edit" @click="openEditModal(item.id)" />
                <b-button icon-right="trash-alt" @click="deleteItem(item.id)" />
              </div>
            </td>
          </tr>
        </template>
      </b-table>
    </BContainer>
  </div>
</template>

<script>
import ApiService from '../../../_api/api.service'
import CompanyEdit from './CompanyEdit.vue'

export default {
  data() {
    return {
      data: [],
      showDetailIcon: true
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      ApiService.get('/company').then(data => {
        this.data = data
      })
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row)
    },
    openEditModal(id) {
      this.$buefy.modal.open({
        parent: this,
        props: { id },
        component: CompanyEdit,
        events: {
          saved: () => {
            this.getData()
          }
        }
      })
    },
    deleteItem(id) {
      this.$buefy.dialog.confirm({
        title: this.$t('title.deletingCompany'),
        message: this.$t('description.deletingCompanyConfirmMessage'),
        confirmText: this.$t('button.deleteCompany'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.delete('/company', { data: { companyId: id } }).then(isDeleted => {
            if (isDeleted) {
              this.getData()
            } else {
              this.deleteItem(id)
            }
          })
        }
      })
    }
  }
}
</script>
